if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();

          
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {

          const variant = this.getSelectedVariant(html);
          console.log(variant);
          this.pickupAvailability?.update(variant);
          // TEMPORARY BUG FIX DUE TO A BUG FROM A SALES APP

          const getProdVariantId = document.querySelector('.custom-product-form-class .custom-form-class .product-variant-id');
          getProdVariantId.value = variant?.id; // update product variant id for the buy form
          const cartButtons = document.querySelector('.add-to-cart-to-checkout .custom-submit-to-cart-button');
          cartButtons.removeAttribute('disabled');
          const getProdPrice = document.querySelector('.price__container .price__sale .price-item--last');
          const getCompareProdPrice = document.querySelector('.price__container .price__sale .price-item--regular');
          const getPriceCurrency = getProdPrice.dataset.currencySign;
          const getCurrencySymbol = getPriceCurrency.match(/^(\D*)\d+(?:\.\d+)?\s*(\D+)$/);
          const moneySymbol = getCurrencySymbol[1];
          const moneyCode = getCurrencySymbol[2];
          if (getProdPrice && variant?.price != null) {

            let rawValue = variant.price;

            const scaledValue = rawValue / 100;

            // Format with commas and two decimals
            const formatted = scaledValue.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });

            getProdPrice.textContent = moneySymbol+formatted+' '+moneyCode; // update product sale price
          } else {
            console.warn("Price element not found or variant.price is undefined");
          }

          if (getCompareProdPrice && variant?.compare_at_price != null) {

            let rawValue = variant.compare_at_price;

            const scaledValue = rawValue / 100;

            // Format with commas and two decimals
            const formatted = scaledValue.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });

            getCompareProdPrice.textContent = moneySymbol+formatted+' '+moneyCode; // update regular sale price
          } else {
            console.warn("Price element not found or variant.price is undefined");
          }

          // END TEMP BUG FIX
          this.updateOptionValues(html);
          console.log(getProdVariantId);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        console.log(variantId);
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
          
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

 

// RM CUSTOM

document.addEventListener('DOMContentLoaded', ()=> {
  new RMProductCustomization
});



customElements.define('product-cart-form', class extends HTMLFormElement {
  constructor() {
      
      super();
  }
}, {extends: 'form'});

class RMProductCustomization {
  constructor() {
    // Product personalizer app, price and custom price elements
    this.pplr_element = document.querySelector('.product-personalizer');
    this.pplr_charge_element = this.pplr_element.querySelector('.a_p_t');
    this.product_quantity = document.querySelector('.quantity__input');
    this.product_price_element = document.querySelector('.product__info-wrapper').querySelector('.price-item--regular');
    this.product_price_wrapper = document.querySelector('.product__info-wrapper').querySelector('.price').closest('[role="status"]');
    if (document.querySelector('.price-item.price-item--last') != undefined) {
      this.product_price_element = document.querySelector('.price-item.price-item--last');
    }
    this.money_sign = this.product_price_element.textContent.trim()[0];
    this.generated_id = this.generateCartId();
    this.custom_prices
    this.custom_subtotal = this.pplr_element.querySelector('.custom-subtotal');
    this.custom_size_charges = this.pplr_element.querySelector('.custom-size-total');
    this.custom_product_price = document.querySelector('.custom-product-price');

    // Pricing Formula Elements
    this.pricing_formula_helper = document.querySelector('.rm-pricing-formula__helper');
    this.formula_options = JSON.parse(this.pricing_formula_helper.textContent);
    this.formula_options_keys = Object.keys(this.formula_options);
    this.length_input = document.querySelector('#cs-length');
    this.width_input = document.querySelector('#cs-width');

    // Custom Size
    this.cs_helper = document.querySelector('.rm-custom-sizing__helper')
    this.cs_product = JSON.parse(this.cs_helper.textContent);

    console.log(this.pplr_element)
    this.initListeners();
  }

  initListeners() {
    this.initcustomSize()
    window.addEventListener('pplrAppInitiated' , (e) => {
      this.pplr_element = document.querySelector('.product-personalizer');
      this.pplr_charge_element = this.pplr_element.querySelector('.a_p_t');
      this.initPplrListener();
    })
    // window.addEventListener('pplrAddToCartCompleted' , (e) => {
    //   console.log("Add to cart completed")
    //   this.postAddOn();
    // })
  }

  initPplrListener() {
    if (this.pplr_element != undefined) {
      console.log("Product Personalizer loaded")
      console.log(this.pplr_element)
      // init custom price element and hide default additional price element
      this.custom_prices = document.createElement('div');
      this.custom_prices.classList.add('custom-prices');
      this.pplr_element.append(this.custom_prices);
      console.log(this.pplr_charge_element)
      this.pplr_charge_element.style.display = "none";

      var observer = new MutationObserver(() => {
        setTimeout(()=> {
          this.updateProductSubtotal();
        }, 100)
      });
      observer.observe(this.pplr_charge_element, {
        subtree: true,
        childList: true,
      });

      this.initPricingFormula();
    }
  }

  initPricingFormula() {
    console.log("init pricing formula")
    this.pricing_formula_helper.setAttribute("generated_id", this.generated_id);
    var size_data = this.getSizeVariant();
    console.log(size_data)
    size_data.input_elements.forEach((input) => {
      input.addEventListener('change', this.addOnsChanged.bind(this));
    })

    if (this.formula_options_keys.length > 0) {
      var has_option = false;
      for (let i = 0; i < this.formula_options_keys.length; i++) {
        var option_input = document.querySelector(`[name="properties[${this.formula_options_keys[i]}]"]`);
        var option_container = option_input?.closest('.pplr-wrapper');
        if (option_input != undefined) {
          has_option = true;
          var observer = new MutationObserver(() => {
            setTimeout(()=> {
              this.addOnsChanged();
            }, 100)
          });
          observer.observe(option_container, {
            subtree: true,
            childList: true,
          });
        }
      }
      if (has_option) {
        this.addOnsChanged()
      }
    }
  }

  updateProductSubtotal() {
    this.updateAddsOnId();
    // Get Additional Cost from Product personalizer app
    var pplr_price = this.pplr_charge_element.querySelector('span');
    var pplr_charge_amount = parseFloat(pplr_price.textContent.replace(this.money_sign, '' ).replace(',', ''));
    this.product_price_element = document.querySelector('.product__info-wrapper').querySelector('.price-item--regular');
    if (document.querySelector('.price-item.price-item--last') != undefined) {
      this.product_price_element = document.querySelector('.price-item.original_price');
    }

    // Get Additional Cost from Pricing formula
    var pricing_formula_price = this.pricing_formula_helper.getAttribute('total_size_price');

    // Total Additional Cost
    var total_additional_cost = pplr_charge_amount * parseFloat(this.product_quantity.value)

    // Include Pricing formula Cost
    if (pricing_formula_price != undefined) {
      total_additional_cost = (parseFloat(pricing_formula_price) + pplr_charge_amount) * parseFloat(this.product_quantity.value);
    }

    // Add or update Additional Charges Element
    if (this.custom_size_charges != undefined) {
      this.custom_size_charges.innerHTML = `<input type="hidden" name="_additional-charges" value="${this.money_sign}${total_additional_cost}" /><span>Additional Charges: </span> ${this.money_sign}${total_additional_cost}`; 
    } else {
      this.custom_size_charges = document.createElement('div');
      this.custom_size_charges.classList.add('custom-size-total');
      this.custom_size_charges.innerHTML = `<input type="hidden" name="_additional-charges" value="${this.money_sign}${total_additional_cost}" /><span>Additional Charges: </span> ${this.money_sign}${total_additional_cost}`; 
      console.log(this.custom_prices)
      this.custom_prices.prepend(this.custom_size_charges);
    }

    // Add or Update Product Price Element
    var product_price = parseFloat(this.product_price_element.textContent.trim().replace(this.money_sign, '').replace(',', ''));
    this.length_input = document.querySelector('#cs-length');
    this.width_input = document.querySelector('#cs-width');
    // console.log("Update price")
    // console.log(product_price)
    // console.log("check tiers");
    // console.log(this.cs_product)
    // Custom Sizing Price
    if (this.length_input != undefined) {
      var area = parseInt(this.length_input.value) * parseInt(this.width_input.value);
      var custom_size_price = parseFloat(area) * parseFloat(this.cs_product.price / 100);
      product_price = custom_size_price.toFixed(2);
      if (this.cs_product.tiers != undefined) {
        var tiers = this.cs_product.tiers.sort((a,b) =>  b.size - a.size);
        var cs_total_price = 0;
        for (let t = 0; t < tiers.length; t++) {
          if (area > tiers[t].size) {
            var current_area = area - tiers[t].size;
            area = tiers[t].size;
            cs_total_price = cs_total_price + (current_area * parseFloat(tiers[t].price.amount));
          }
        }
        product_price = cs_total_price;
        this.length_input.setAttribute('total_cost', cs_total_price);
      }
    }

    product_price = product_price;
    // console.log(product_price)
  
    if (this.custom_product_price != undefined) {
      this.custom_product_price.innerHTML = `<span>Product Price: </span> ${this.money_sign}${product_price.toFixed(2)}`; 
    } else {
      this.custom_product_price = document.createElement('div');
      this.custom_product_price.classList.add('custom-product-price');
      this.custom_product_price.innerHTML = `<span>Product Price: </span> ${this.money_sign}${product_price.toFixed(2)}`; 
      this.custom_prices.append(this.custom_product_price);
    }

    // Add or Update Subtotal Element
    var subtotal_price = (product_price + total_additional_cost).toFixed(2);

    if (this.custom_subtotal != undefined) {
      this.custom_subtotal.innerHTML = `<span>Subtotal: </span> ${this.money_sign}${subtotal_price}`; 
    } else {
      this.custom_subtotal = document.createElement('div');
      this.custom_subtotal.classList.add('custom-subtotal');
      this.custom_subtotal.innerHTML = `<span>Subtotal: </span> ${this.money_sign}${subtotal_price}`; 
      this.custom_prices.append(this.custom_subtotal);
    }
  }

  generateCartId() {
    const now = new Date();
    const year = now.getFullYear().toString();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    
    return year + month + day + hours + minutes + seconds;
  }

  getSizeVariant() {
    var variant_selectors = document.querySelector('variant-selects').querySelectorAll('fieldset');
    var found = false;
    var variant_value = undefined;
    var return_value = {};

    for (let i = 0; i < variant_selectors.length; i++) {
      if (found != true) {
        // Get Active variant
        var variant_name = variant_selectors[i].querySelector('.form__label').textContent;
        if (variant_name.toLowerCase().includes('size')) {
          // get value
          var selected_variant = variant_selectors[i].querySelector('input:checked');
          if (selected_variant != undefined) {
            variant_value = variant_selectors[i].querySelector('input:checked').value;
          } else {
            variant_value = variant_selectors[i].querySelector('input').value;
            selected_variant = variant_selectors[i].querySelector('input');
          }
          if (variant_value != undefined) {
            found = true;
            return_value["input_elements"] = variant_selectors[i].querySelectorAll('input');
            return_value["value"] = variant_value;
            return_value["input_element"] = selected_variant;
          }
        }
      }
    }
    return return_value
  }
  updateAddsOnId() {
    var pricing_formula_price = this.pricing_formula_helper.getAttribute('total_size_price');
    var check_input = document.querySelector('.rm-cs__id');
    var length = document.querySelector('#cs-length');
    pricing_formula_price = parseFloat(pricing_formula_price)

    if (pricing_formula_price > 0 || length != undefined) {
      if (check_input == undefined) {
        var size_variant = this.getSizeVariant();
        var form_id = size_variant.input_element.getAttribute('form');
        var form = document.querySelector(`#${form_id}`);
        var generated_input = document.createElement('input');
        generated_input.setAttribute('type', "hidden");
        generated_input.setAttribute("name","properties[Adds On Id]");
        generated_input.classList.add("rm-cs__id");
        generated_input.setAttribute("value", this.generated_id);
        form.append(generated_input)
      }
    } else {
      if (check_input != undefined) {
        check_input.remove();
      }
    }
    
  }
  addOnsChanged(e) {
    console.log("addOnsChanged");
    // error
    const parent = e.target.closest('.rm-cs__input-container');
    var error = parent.querySelector('.error');
    if (e.target.value < parseInt(e.target.getAttribute("min")) || e.target.value > parseInt(e.target.getAttribute("max"))) {
      if (error == undefined) {
        parent.innerHTML += `<p class="error">Enter between ${e.target.getAttribute("min")}in to ${e.target.getAttribute("max")}in</p>`;
        parent.classList.add("input-error");
      }
      return
    } else {
      if (error != undefined) {
        error.remove();
        parent.classList.remove("input-error");
      }
    }
    setTimeout(() => {
      let size_variant = this.getSizeVariant();
      if (size_variant.value != undefined) {

        // Get All Active options
        var selected_addOns = {};
        var total_price = [];
        var total_size = [];
        for (let o = 0; o < this.formula_options_keys.length; o++) {
          var option_input = document.querySelector(`[name="properties[${this.formula_options_keys[o]}]"]`);
          if (option_input != undefined) {
            if (!option_input.disabled && this.formula_options[this.formula_options_keys[o]].options[option_input.value] != undefined) {
    
              if (selected_addOns[this.formula_options[this.formula_options_keys[o]].product] == undefined) {
                selected_addOns[this.formula_options[this.formula_options_keys[o]].product] = {};
                selected_addOns[this.formula_options[this.formula_options_keys[o]].product]["price"] = 0;
                selected_addOns[this.formula_options[this.formula_options_keys[o]].product]["attributes"] = [];
              }

              total_price.push(parseFloat(this.formula_options[this.formula_options_keys[o]].price / 100));
              total_size.push(parseFloat(this.formula_options[this.formula_options_keys[o]].options[option_input.value]));

              selected_addOns[this.formula_options[this.formula_options_keys[o]].product].price = selected_addOns[this.formula_options[this.formula_options_keys[o]].product].price + parseFloat(this.formula_options[this.formula_options_keys[o]].price / 100)
              selected_addOns[this.formula_options[this.formula_options_keys[o]].product].attributes.push({
                "name": this.formula_options_keys[o],
                "value": option_input.value,
                "size": this.formula_options[this.formula_options_keys[o]].options[option_input.value],
                "price": parseFloat(this.formula_options[this.formula_options_keys[o]].price / 100)
              });
              selected_addOns[this.formula_options[this.formula_options_keys[o]].product]["product_price"] = parseFloat(this.formula_options[this.formula_options_keys[o]].product_price / 100)
              
            }
          }
        }
        
        // let pricing formula
        let size = size_variant.value.split('x');
        let size_i = [];
        let size_value = 0;

        if (size_variant.value.toLowerCase() == "custom size") {
          var length = document.querySelector('#cs-length');
          var width = document.querySelector('#cs-width');
          size_i.push(parseFloat(length.value));
          size_i.push(parseFloat(width.value));
        } else {
          for (let i = 0; i < size.length; i++) {
            size_i.push(parseFloat(size[i]));
          }
        }
        
        
        size_value = size_i.reduce((a, b)=> a*b, 1);
        let total_size_price = 0;
        console.log("All sizes and price");
        for (let i = 0; i < total_size.length; i++) {
          total_size_price = total_size_price + (size_value * total_size[i] * total_price[i]);
        }

        if (selected_addOns != {}) {
          this.pricing_formula_helper.setAttribute("add_ons", JSON.stringify(selected_addOns));
          this.pricing_formula_helper.setAttribute("total_size_price", total_size_price.toFixed(2));
          this.pricing_formula_helper.setAttribute("total_size", size_value);
        } else {
          this.pricing_formula_helper.removeAttribute("add_ons");
          this.pricing_formula_helper.removeAttribute("total_size_price");
          this.pricing_formula_helper.removeAttribute("total_size");
        }
        
        

        // update subtotal
        if (this.pplr_charge_element != undefined) {
          setTimeout(()=> {
            this.updateProductSubtotal()
          }, 100)
          // addAddOns()
        }
      }
    }, 100)
  }

  postAddOn() {
    console.log("ADD Ons to cart")
    var formula_options = JSON.parse(this.pricing_formula_helper.getAttribute('add_ons'));
    var data = {}
    var items = []
    var quantity = document.querySelector('.quantity__input')
    if (formula_options != undefined) {
      var formula_options_keys = Object.keys(formula_options);
      for (let i = 0; i < formula_options_keys.length; i++) {
        var item = {}
        var addon_product =  formula_options[formula_options_keys[i]]
        var product_price = parseFloat(addon_product.product_price);
        var total_price = parseFloat(pricing_formula_helper.getAttribute('total_size_price'));
        var total_quantity = Math.ceil(total_price / product_price) * parseFloat(quantity.value);
  
        item.id = formula_options_keys[i];
        item.properties = {};
        item.properties["Id"] = pricing_formula_helper.getAttribute('generated_id');
        item.properties["_Cost"] = total_price;
        item.quantity = total_quantity;
        for (let a = 0; a < addon_product.attributes.length; a++) {
          item.properties[addon_product.attributes[a].name] = addon_product.attributes[a].value;
        }
        items.push(item);
      }
    }
    data.items = items;
  
    console.log("Add add ons")
    console.log(formula_options)
    console.log(data)
    fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
      body: JSON.stringify(data) 
    })
    .then((response) => response.json())
    .then((response) => {
      console.log("Success")
    });
  }

  initcustomSize() {
    var custom_size = document.querySelector('[value="Custom Size"]');
    if (custom_size != undefined) {
      var name = custom_size.getAttribute('name');
      var all_size_inputs = document.querySelectorAll(`[name="${name}"]`);
      var field_set = custom_size.closest('.product-form__input');
      var form_id = custom_size.getAttribute('form');
      var form = document.getElementById(form_id);
      var custom_size_inputs = document.createElement('div');
      custom_size_inputs.classList.add("rm-product__custom-sizes");
      custom_size_inputs.classList.add("flex-container");
      custom_size_inputs.setAttribute('aria-hidden', true);
      custom_size_inputs.innerHTML = '<div class="length rm-cs__input-container"></div><div class="width rm-cs__input-container"></div>';
  
      field_set.append(custom_size_inputs);
      var pplr_element = document.querySelector('.product-personalizer')
      all_size_inputs.forEach((input) => {
        if (input.getAttribute('value') == "Custom Size" && input.checked) {
          console.log("Show CS")
          custom_size_inputs.setAttribute('aria-hidden', false);
          custom_size_inputs.querySelector('.length').innerHTML = `<label for="cs-length">Length</label><input  id="cs-length" type="number" name="length" step="0.1" min="12" max="48" placeholder="12in to 48in" required form="${form_id}" />`;
          custom_size_inputs.querySelector('.width').innerHTML = `<label for="cs-width">Width</label><input id="cs-width" type="number" name="width" step="0.1" min="12" max="96" placeholder="12in to 96in" required form="${form_id}" />`;
          this.updateAddsOnId();
          custom_size.closest('product-info').querySelector('.price__container').closest('[role="status"]').style.display = "none";
          var cs_inputs = document.querySelectorAll('.rm-cs__input-container');
          cs_inputs.forEach((cs_input) => {
            cs_input.addEventListener('change', (e) => {
              // Product personalizer subtotal
              this.addOnsChanged(e)
            })
          })
        }
        input.addEventListener('change', ()=> {
          if (input.getAttribute('value') == "Custom Size") {
            console.log("Show CS")
            custom_size_inputs.setAttribute('aria-hidden', false);
            custom_size_inputs.querySelector('.length').innerHTML = `<label for="cs-length">Length</label><input  id="cs-length" type="number" name="length" step="0.1" min="12" max="48" placeholder="12in to 48in" required form="${form_id}" />`;
            custom_size_inputs.querySelector('.width').innerHTML = `<label for="cs-width">Width</label><input id="cs-width" type="number" name="width" step="0.1" min="12" max="96" placeholder="12in to 96in" required form="${form_id}" />`;
            var cs_inputs = document.querySelectorAll('.rm-cs__input-container');
            cs_inputs.forEach((cs_input) => {
              cs_input.addEventListener('change', (e) => {
                  // Product personalizer subtotal
                  this.addOnsChanged(e)
                
              })
            })
            this.updateAddsOnId();
            custom_size.closest('product-info').querySelector('.price__container').closest('[role="status"]').style.display = "none";
          } else {
            console.log("Hide cs")
            custom_size_inputs.setAttribute('aria-hidden', true);
            custom_size_inputs.querySelector('.length').innerHTML = '';
            custom_size_inputs.querySelector('.width').innerHTML = '';
            custom_size.closest('product-info').querySelector('.price__container').closest('[role="status"]').style.display = "block";
          }
          if (pplr_element != undefined) {
            // Product personalizer subtotal
            this.updateProductSubtotal();
          }
        })
        
      })
      console.log("Init custom size");
      
      form.addEventListener('submit', (e) => {
        console.log("Submitted");
      })
   
    }
  }
}